import { BodyProps } from "@ofqual/portal-activity-feed";
import { EventNotification } from "../../../domain/EventNotification";
import { fieldLabels } from "../../sections/fieldLabels";

export type EventNotificationActivityFeedProps = {
  eventNotification: EventNotification | null;
};

export enum ActionType {
  CloseNotification = 1,
  ReopenNotification = 2,
  RequestInformation = 3,
  AttachDocument = 4,
  SendMessage = 5,
}

export type FieldChange = {
  field: keyof typeof fieldLabels;
  oldValue: string | null;
  newValue: string | null;
};

export type ChangeActivityBody = {
  changes: FieldChange[];
};

export type CloseActivityBody = {
  summary: string;
  reason: string;
};

export type AssignActivityBody = {
  summary: string;
};

export type MessageActivityBody = {
  message: string;
};

export type AttachmentActivityBody = {
  note: string;
  documents: {
    blobId: string;
    fileName: string;
    contentType: string;
  }[];
};

export type ShareBody = {
  whitelist: string[];
};

  export type AttachmentBodyProps = {
    token: string;
    bodyProps: BodyProps<AttachmentActivityBody>;
  };